import { GraphicsApi } from "../api/GraphicsApi";

export const GraphicsSearchModule = {
    state: {
      results: [],
      loading: false,
      searchTermId: null,
      lastSearch: null,
      displaySection: false
    },
    mutations: {
      setResults(state, { results, searchTermId, search}) {
        state.results = results;
        state.searchTermId = searchTermId;
        state.lastSearch = search;
        state.loading = false;
      },
      setLoading(state, status) {
        state.loading = status;
      },
      setDisplaySection(state, status){
        state.displaySection = status;
      }
    },
    actions: {
      async getRelevantGraphics({ state, commit }, search) {
        if (!search || (state.lastSearch === search && state.results.length > 0)) {
          return;
        }
        commit("setLoading", true);
        try {
          const data = {
            search,
            page: 1,
            limit: 8,
            titles: [],
            years: [],
            categories: [],
          };
          const response = await GraphicsApi.getGraphicsResults(data);
          const resultData = response.data.graphics
          commit("setResults", {
            results: resultData,
            searchTermId: response.data.searchTermId,
            search,
          });
          commit("setDisplaySection", resultData.length > 0);

        } catch (error) {
          commit("setLoading", false);
        }
      },
    },
  };
